import React from "react";

import { TiLocationOutline } from 'react-icons/ti';
import { FaMobileAlt } from 'react-icons/fa';
import { BsChatSquare } from 'react-icons/bs';
import { AiFillFacebook } from 'react-icons/ai';
import { AiOutlineWhatsApp } from 'react-icons/ai';
import { FaInstagram } from 'react-icons/fa';
import "./contact.scss";

const Contact = () => {
  return (
    <>
      <div style={{width: '100%', maxWidth: '900px', margin: '2rem auto', borderRadius: '1rem', overflow: 'hidden'}}>
        <iframe
          title="Ubicación El Rinconcito de la Pizza"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3930.234964479836!2d-84.6565239!3d10.4527965!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8fa00d007906bc51%3A0xd7abdf295c32cdfe!2sEl%20rinconcito%20de%20la%20pizza!5e0!3m2!1ses!2scr!4v1693590000000!5m2!1ses!2scr"
          width="100%"
          height="450"
          style={{border:0}}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
      <section id="contact" className="contact">
        <div className="container">
          <div className="contactAddress">
            <div className="contactAddressDetails">
              <h2><TiLocationOutline /></h2>
              <h1>Location</h1>
              <p>La Fortuna</p>
            </div>
            <div className="contactAddressDetails">
              <h2><FaMobileAlt /></h2>
              <h1>phone</h1>
                <p>+506 6452 1140</p>
            </div> 
            <div className="contactAddressDetails">
              <h2><BsChatSquare /></h2>
              <h1>Chat</h1>
              <div className="social">
                  <a href="https://www.facebook.com/bombisfastfood" target="_blank" rel="noopener noreferrer">
                    <AiFillFacebook />
                  </a>
                  <a href="https://wa.me/50664521140?text=Hola.%20Quisiera%20ordenar%20pizza" target="_blank" rel="noopener noreferrer">
                    <AiOutlineWhatsApp />
                  </a>
                  <a href="https://www.instagram.com/explore/locations/100937512568078/el-rinconcito-de-la-pizza/" target="_blank" rel="noopener noreferrer">
                    <FaInstagram />
                  </a>
              </div>
            </div>
          </div>

    {/* Formulario eliminado */}
        </div>
      </section>
    </>
  );
};

export default Contact;
